import React from 'react';

import { Typography, Link } from 'vindi-ds-components';

import styles from './styles';
import templates from '../../templates.json';

function WarningText() {
  const warning = templates.form.warningText;
  const { message } = warning;
  const messages = message.split(':usage_terms');
  const firstToken = messages[0];
  let lastToken = messages[1];
  lastToken = lastToken.substring(0, lastToken.indexOf(':privacy_policy'));

  const link = (key) => (
    <Link href={warning[key].url} target='_blank' rel='noreferrer' style={styles.linkPading}>{warning[key].label}</Link>
  );

  return (
    <Typography style={styles.warningText}>
      {firstToken}{link('usage_terms')}{lastToken}{link('privacy_policy')}
    </Typography>
  );
}

export default WarningText;
